"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = exports.assetIconForType = exports.LabelsPopoverContext = exports.buildLabelsPopoverContext = exports.LabelButtonContext = exports.defaultLabelRenderControls = exports.disabledSiteUrls = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../gen-src/icons");
var RemoteTypeIcon_1 = require("../dataGrid/cellFormatters/RemoteTypeIcon");
var SiteUrlsContext_1 = require("../urls/SiteUrlsContext");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
exports.disabledSiteUrls = (0, SiteUrlsContext_1.createDefaultSiteUrls)('');
exports.defaultLabelRenderControls = {
    siteUrls: exports.disabledSiteUrls,
    linksDisabled: true,
    kind: 'chip',
};
exports.LabelButtonContext = react_1.default.createContext(exports.defaultLabelRenderControls);
function buildLabelsPopoverContext(props) {
    var _a, _b, _c, _d, _e, _f;
    var totalUpstream = props.category === 'warning' ? (_b = (_a = props.upstream) === null || _a === void 0 ? void 0 : _a.labels.length) !== null && _b !== void 0 ? _b : 0 : 0;
    var totalParented = (_d = (_c = props.parented) === null || _c === void 0 ? void 0 : _c.labels.length) !== null && _d !== void 0 ? _d : 0;
    var totalAnchored = (_f = (_e = props.anchored) === null || _e === void 0 ? void 0 : _e.labels.length) !== null && _f !== void 0 ? _f : 0;
    var totalLabels = (totalUpstream + totalParented + totalAnchored);
    var collapse = 'disallow';
    if (totalLabels > 1 && totalLabels <= 3) {
        collapse = 'allow';
    }
    else if (totalLabels > 3) {
        collapse = 'prefer';
    }
    return { collapse: collapse, content: props.content, category: props.category };
}
exports.buildLabelsPopoverContext = buildLabelsPopoverContext;
exports.LabelsPopoverContext = react_1.default.createContext({
    collapse: 'disallow',
    category: 'warning',
});
function assetIconForType(type, remoteType) {
    switch (type) {
        case null:
            return null;
        case 'CloudFile':
        case 'File':
            return react_1.default.createElement(icons_1.SvgSpacesMediumFile, null);
        case 'database':
        case 'DatabaseServer':
        case 'WebDataConnector':
            return react_1.default.createElement(icons_1.SvgSpacesMediumExternalServer, null);
        case 'table':
        case 'DatabaseTable':
            return react_1.default.createElement(icons_1.SvgSpacesMediumTable, null);
        case 'Flow':
        case 'flow':
            return react_1.default.createElement(icons_1.SvgSpacesMediumFlow, null);
        case 'datasource':
        case 'PublishedDatasource':
        case 'EmbeddedDatasource':
            return react_1.default.createElement(icons_1.SvgSpacesMediumDs, null);
        case 'column':
        case 'Column':
            return remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : null;
        case 'VirtualConnection':
        case 'virtualConnection':
            return react_1.default.createElement(icons_1.SvgVirtualConnection, null);
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return react_1.default.createElement(icons_1.SvgVirtualConnectionTable, null);
        case 'Field':
        case 'View':
        case 'Metric':
        case 'Workbook':
            return null;
        default:
            (0, TypescriptHelpers_1.assertUnreachable)(type);
            return null;
    }
}
exports.assetIconForType = assetIconForType;
// TODO: refactor to use groupByToMultimap
var groupBy = function (arr, key) {
    return arr.reduce(function (groups, item) {
        var _a;
        var k = key(item);
        !groups.has(k) ? groups.set(k, [item]) : (_a = groups.get(k)) === null || _a === void 0 ? void 0 : _a.push(item);
        return groups;
    }, new Map());
};
exports.groupBy = groupBy;
//# sourceMappingURL=LabelHelpers.js.map